<template>
  <date-picker v-model="date" :min="minDate" :max="maxDate" :auto-close="autoClose" :timeout="timeout">
    <v-text-field v-bind="$attrs" :value="date" type="date" @click.prevent>

      <template #prepend v-if="$slots.prepend">
        <slot name="prepend"></slot>
      </template>

      <template #prepend-inner v-if="$slots['prepend-inner']">
        <slot name="prepend-inner"></slot>
      </template>

      <template #append-inner v-if="$slots['append-inner']">
        <slot name="append-inner"></slot>
      </template>

      <template #append v-if="$slots.append">
        <slot name="append"></slot>
      </template>

      <template #label v-if="$slots.label">
        <slot name="label"></slot>
      </template>

      <template #details v-if="$slots.details">
        <slot name="details"></slot>
      </template>

      <template #messages v-if="$slots.messages">
        <slot name="messages"></slot>
      </template>

      <template #loader v-if="$slots.loader">
        <slot name="loader"></slot>
      </template>
    </v-text-field>

    <!-- Date picker specific slots -->
    <template #activator="{ props: activatorProps }" v-if="$slots.activator">
      <slot name="activator" :props="activatorProps"></slot>
    </template>
  </date-picker>
</template>

<script setup>
import { computed } from 'vue'
import DatePicker from '@/Components/components/DatePicker.vue'

defineOptions({
  name: 'MkDatePicker',
})

const props = defineProps({
  modelValue: String,
  minDate: String,
  maxDate: String,
  autoClose: {
    type: Boolean,
    default: true,
  },
  timeout: {
    type: Number,
    default: 3, // seconds
  },
})

const emit = defineEmits(['update:modelValue'])

const date = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})
</script>
